/**
 * What's Included Quick View — opens krs-bundle-builder modal shell
 * populated from each include tile's JSON payload.
 */
(function () {
  if (window.__bundleIncludesQuickViewBound) return;
  window.__bundleIncludesQuickViewBound = true;

  var MODAL_ID = 'BundleIncludesQuickView';
  var modal = null;
  var returnFocusEl = null;

  function getModal() {
    if (modal && document.body.contains(modal)) return modal;
    modal = document.getElementById(MODAL_ID);
    return modal;
  }

  function ensureModalOnBody() {
    var el = getModal();
    if (!el) return null;
    if (el.parentNode !== document.body) {
      document.body.appendChild(el);
    }
    return el;
  }

  function parsePayload(trigger) {
    var wrap = trigger.closest('.bundle-includes__item');
    if (!wrap) return null;
    var script = wrap.querySelector('[data-bundle-includes-qv-data]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (err) {
      return null;
    }
  }

  function buildGallery(images) {
    var el = getModal();
    if (!el) return;
    var slider = el.querySelector('[data-role="bundle-includes-qv-slider"]');
    var controls = el.querySelector('[data-role="bundle-includes-qv-controls"]');
    var dots = el.querySelector('[data-role="bundle-includes-qv-dots"]');
    if (!slider) return;

    var list = Array.isArray(images) ? images.filter(Boolean) : [];
    slider.innerHTML = '';
    if (dots) dots.innerHTML = '';

    if (!list.length) {
      if (controls) controls.hidden = true;
      return;
    }

    list.forEach(function (src, index) {
      var li = document.createElement('li');
      li.id = 'Slide-BundleIncludesQuickView-' + (index + 1);
      li.className =
        'krs-bundle-builder__modal-media-item product__media-item grid__item slider__slide' +
        (index === 0 ? ' is-active' : '');
      li.setAttribute('data-bundle-includes-qv-slide-index', String(index + 1));

      var img = document.createElement('img');
      img.src = src;
      img.alt = '';
      img.loading = index === 0 ? 'eager' : 'lazy';
      if (index === 0) img.fetchPriority = 'high';
      li.appendChild(img);
      slider.appendChild(li);

      if (dots && list.length > 1) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className =
          'product-media-gallery__dot' + (index === 0 ? ' product-media-gallery__dot--active' : '');
        dot.setAttribute('data-bundle-includes-qv-dot-index', String(index + 1));
        dot.setAttribute('aria-label', 'Go to image ' + (index + 1) + ' of ' + list.length);
        dot.setAttribute('aria-current', index === 0 ? 'true' : 'false');
        dots.appendChild(dot);
      }
    });

    if (controls) controls.hidden = list.length < 2;
    slider.scrollLeft = 0;
  }

  function syncActiveDot(index) {
    var el = getModal();
    if (!el) return;
    var dots = el.querySelectorAll('[data-bundle-includes-qv-dot-index]');
    var slides = el.querySelectorAll('[data-bundle-includes-qv-slide-index]');
    Array.prototype.forEach.call(dots, function (dot, i) {
      var active = i + 1 === index;
      dot.classList.toggle('product-media-gallery__dot--active', active);
      dot.setAttribute('aria-current', active ? 'true' : 'false');
    });
    Array.prototype.forEach.call(slides, function (slide, i) {
      slide.classList.toggle('is-active', i + 1 === index);
    });
  }

  function scrollToSlide(index) {
    var el = getModal();
    if (!el) return;
    var slider = el.querySelector('[data-role="bundle-includes-qv-slider"]');
    var slide = el.querySelector('[data-bundle-includes-qv-slide-index="' + index + '"]');
    if (!slider || !slide) return;
    slider.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    syncActiveDot(index);
  }

  function currentSlideIndex() {
    var el = getModal();
    if (!el) return 1;
    var dots = el.querySelectorAll('[data-bundle-includes-qv-dot-index]');
    var current = 1;
    Array.prototype.forEach.call(dots, function (dot, index) {
      if (dot.classList.contains('product-media-gallery__dot--active')) current = index + 1;
    });
    return current;
  }

  function populate(payload) {
    var el = getModal();
    if (!el || !payload) return;

    var title = el.querySelector('[data-role="bundle-includes-qv-title"]');
    var description = el.querySelector('[data-role="bundle-includes-qv-description"]');
    var link = el.querySelector('[data-role="bundle-includes-qv-link"]');

    if (title) title.textContent = String(payload.title || '').trim();

    if (description) {
      var html = String(payload.descriptionHtml || '').trim();
      if (html) {
        description.innerHTML = html;
        description.hidden = false;
        description.style.display = '';
      } else {
        description.innerHTML = '';
        description.hidden = true;
        description.style.display = 'none';
      }
    }

    if (link) {
      var url = String(payload.url || '').trim();
      if (url) {
        link.setAttribute('href', url);
        link.hidden = false;
        link.style.display = '';
      } else {
        link.setAttribute('href', '#');
        link.hidden = true;
        link.style.display = 'none';
      }
    }

    buildGallery(payload.images || []);
  }

  function openModal(payload, trigger) {
    var el = ensureModalOnBody();
    if (!el) return;
    populate(payload);
    returnFocusEl = trigger && trigger.focus ? trigger : document.activeElement;
    el.setAttribute('open', '');
    el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('krs-bundle-builder__modal-open');
    var dialog = el.querySelector('.krs-bundle-builder__modal-dialog');
    if (dialog && dialog.focus) dialog.focus();
  }

  function closeModal(restoreFocus) {
    var el = getModal();
    if (!el || !el.hasAttribute('open')) return;
    el.removeAttribute('open');
    el.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('krs-bundle-builder__modal-open');
    if (restoreFocus && returnFocusEl && returnFocusEl.focus) returnFocusEl.focus();
    returnFocusEl = null;
  }

  function bindModalChrome() {
    var el = getModal();
    if (!el || el.__bundleIncludesQvBound) return;
    el.__bundleIncludesQvBound = true;

    Array.prototype.forEach.call(el.querySelectorAll('[data-bundle-includes-qv-close]'), function (node) {
      node.addEventListener('click', function () {
        closeModal(true);
      });
    });

    var prev = el.querySelector('[data-bundle-includes-qv-prev]');
    var next = el.querySelector('[data-bundle-includes-qv-next]');
    var dots = el.querySelector('[data-role="bundle-includes-qv-dots"]');
    var slider = el.querySelector('[data-role="bundle-includes-qv-slider"]');

    if (prev) {
      prev.addEventListener('click', function () {
        scrollToSlide(Math.max(1, currentSlideIndex() - 1));
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        var total = el.querySelectorAll('[data-bundle-includes-qv-dot-index]').length;
        scrollToSlide(Math.min(total, currentSlideIndex() + 1));
      });
    }
    if (dots) {
      dots.addEventListener('click', function (event) {
        var dot = event.target.closest('[data-bundle-includes-qv-dot-index]');
        if (!dot) return;
        scrollToSlide(Number(dot.getAttribute('data-bundle-includes-qv-dot-index')) || 1);
      });
    }
    if (slider) {
      slider.addEventListener(
        'scroll',
        function () {
          if (slider.__qvScrollTicking) return;
          slider.__qvScrollTicking = true;
          requestAnimationFrame(function () {
            slider.__qvScrollTicking = false;
            var slides = el.querySelectorAll('[data-bundle-includes-qv-slide-index]');
            if (!slides.length) return;
            var left = slider.scrollLeft;
            var closest = 1;
            var closestDist = Infinity;
            Array.prototype.forEach.call(slides, function (slide, index) {
              var dist = Math.abs(slide.offsetLeft - left);
              if (dist < closestDist) {
                closestDist = dist;
                closest = index + 1;
              }
            });
            syncActiveDot(closest);
          });
        },
        { passive: true }
      );
    }
  }

  function onDocumentClick(event) {
    var trigger = event.target.closest('[data-bundle-includes-qv]');
    if (!trigger) return;
    event.preventDefault();
    var payload = parsePayload(trigger);
    if (!payload) return;
    bindModalChrome();
    openModal(payload, trigger);
  }

  function onKeydown(event) {
    if ((event && event.key) !== 'Escape') return;
    var el = getModal();
    if (!el || !el.hasAttribute('open')) return;
    event.preventDefault();
    closeModal(true);
  }

  function init() {
    document.addEventListener('click', onDocumentClick);
    document.addEventListener('keydown', onKeydown);
    bindModalChrome();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
